import type { EntryPoint, EntryPointComponent, PreloadFetchPolicy } from 'react-relay';

import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

import parameters, {
	type HomeStarredListQuery,
} from './starred-list/__generated__/HomeStarredListQuery.graphql';
import type { Props } from './starred-list/types';

type EntryPointParams = { cypherQuery: string; queryContext: string };
const fetchPolicy: PreloadFetchPolicy = 'store-or-network';

export const starredListEntryPoint: EntryPoint<
	EntryPointComponent<
		{
			queryReference: HomeStarredListQuery;
		},
		{},
		Props,
		{}
	>,
	EntryPointParams
> = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "@atlassian/home-starred-entrypoint" */ './starred-list/HomeStarredListQuery'
			).then((module) => ({ default: module.HomeStarredListQuery })), { moduleId: "86c115a4", moduleName: "HomeStarredListQuery", modulePath: "../platform/packages/townsquare/home-starred/src/starred-list/HomeStarredListQuery.tsx", priority: "interaction", moduleId: 'starredListEntryPoint' },
	),
	getPreloadProps: ({ cypherQuery, queryContext }: EntryPointParams) => ({
		queries: {
			queryReference: {
				parameters,
				variables: {
					cypherQuery,
					queryContext,
					first: 250,
				},
				options: {
					fetchPolicy,
				},
			},
		},
	}),
});
